// extracted by mini-css-extract-plugin
export var searchHeader = "_5a-0";
export var searchHeaderDark = "_5a-1";